import React from "react";
import { BsFacebook, BsInstagram, BsLinkedin, BsGithub } from "react-icons/bs";
import { SiCodewars, SiGmail } from "react-icons/si";
import { motion } from "framer-motion";

const Fixed = () => {
  const parent = {
    hidden: {
      y: "-200vh",
    },
    visible: {
      color: "rgb(56 189 248 / 0.8)",
      y: "0",

      transition: {
        delay: 3,

        type: "spring",
        stiffness: 130,
        damping: 7,
        Bounce: 100,
      },
    },
  };
  const icons = { scale: 1.1 };

  return (
    <motion.div
      variants={parent}
      initial="hidden"
      animate="visible"
      className="fixed left-4 bottom-1/4 -translate-y-2/4  z-30 dark:z-40"
    >
      <div className="flex flex-col gap-3 items-center">
        <div className="w-2 ph:w-[6px] h-screen bg-sky-400/80 rounded-xl   "></div>
        <motion.a
          href="https://www.facebook.com/xCHIVASx/"
          target="_blank"
          rel="noreferrer"
          whileHover={icons}
        >
          <BsFacebook className="cursor-pointer  text-4xl  ph:text-2xl" />
        </motion.a>

        <motion.a
          whileHover={icons}
          target="_blank"
          rel="noreferrer"
          href="https://www.instagram.com/fedirouatbi/"
        >
          <BsInstagram className="cursor-pointer text-4xl  ph:text-2xl" />
        </motion.a>
        <motion.a
          whileHover={icons}
          href="https://www.linkedin.com/in/fedi-rouatbi-93554b195/"
          target="_blank"
          rel="noreferrer"
        >
          <BsLinkedin className="cursor-pointer text-4xl ph:text-2xl" />
        </motion.a>
        <motion.a
          whileHover={icons}
          target="_blank"
          rel="noreferrer"
          href="https://github.com/FediRouatbi"
        >
          <BsGithub className="cursor-pointer text-4xl  ph:text-2xl" />
        </motion.a>
        <motion.a
          whileHover={icons}
          target="_blank"
          rel="noreferrer"
          href="https://www.codewars.com/users/fedirouatbi"
        >
          <SiCodewars className="cursor-pointer text-4xl  ph:text-2xl" />
        </motion.a>
        <motion.a whileHover={icons} href="mailto: fedirouatbi@gmail.com">
          <SiGmail className="cursor-pointer text-4xl  ph:text-2xl" />
        </motion.a>
      </div>
    </motion.div>
  );
};

export default Fixed;
